import CallableDDITextArea from "Components/Shared/CallableDDITextArea";
import CarrierType from "Components/Shared/CarrierType";
import GlobalDDIClassification from "Components/Shared/GlobalDDIClassification";
import { Field, Formik } from "formik";
import { useTicket } from "Hooks/Endpoints";
import React from "react";
import {
  Button,
  Container,
  Dimmer,
  Form,
  Icon,
  Loader,
  Menu,
  Segment,
} from "semantic-ui-react";
import * as yup from "yup";

const validation = yup.object().shape({
  ddis: yup.string().required(),
  classification: yup.string().required(),
  type: yup.string().required(),
  carrier: yup.string().required(),
  features: yup.array().required(),
});

type GlobalNumberFormProps = {
  onBack: Function;
};

const GlobalNumberForm = ({ onBack }: GlobalNumberFormProps) => {
  const { saveGlobalNumberRequest, loading } = useTicket();

  const initValues = {
    ddis: "",
    classification: "standard",
    type: "VOIP",
    carrier: "BT",
    features: ["voice"],
  };

  return (
    <Container>
      <Dimmer active={loading} inverted>
        <Loader inverted />
      </Dimmer>

      <Menu fluid stackable>
        <Menu.Item header onClick={() => onBack()}>
          <Icon name='x' />
        </Menu.Item>
        <Menu.Item header>Global Number Pool Request</Menu.Item>
      </Menu>
      <Segment>
        <Formik
          initialValues={initValues}
          onSubmit={(values) => {
            saveGlobalNumberRequest(values);
            setTimeout(() => onBack(), 1000);
          }}
          validationSchema={validation}
          render={({ handleSubmit, isValid, errors }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Field
                  name='ddis'
                  label='DDIs'
                  component={CallableDDITextArea}
                />

                <GlobalDDIClassification
                  name='classification'
                  label='Classification'
                />

                <CarrierType name='carrier' label='Select Carrier' />

                <Button primary disabled={!isValid}>
                  Submit
                </Button>
              </Form>
            );
          }}
        />
      </Segment>
    </Container>
  );
};

export default GlobalNumberForm;
